export abstract class AbstractCommand {
  constructor(public readonly type: string) {
  }
}
